module.exports = __webpack_public_path__ + "img/2yuI2rEeOhSQ8e7ELmvU8U.38827fd6.svg";